import React, {useState} from 'react';
import DatePicker from "react-datepicker";
import {useDispatch, useSelector} from "react-redux";
import useOnClickOutside from "use-onclickoutside";
import {format, startOfMonth, endOfMonth, addMonths, startOfWeek, endOfWeek, startOfYear, endOfYear } from "date-fns";

import * as actionTypes from '../../../store/actions/actionTypes';
import TabItem from "./TabItem";
import useBookingListNavigation from "../../../utils/bookingListNavigation";
import {bookingListSet} from "../../../store/actions/bookingList";

const DATE_SELECTOR_THIS_WEEK = 'this-week';
const DATE_SELECTOR_PREVIOUS_WEEK = 'previous-week';

const BookingList_Tabs = () => {
    const [datePopupVisible, setDatePopupVisible] = useState(false);
    const bookingListVars = useSelector(state => state.bookingList);
    const selectedHospital = useSelector(state => state.auth.selectedHospital);
    const dispatch = useDispatch();
    const {pushBookingListUrl} = useBookingListNavigation();
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(null);

    const ref = React.useRef(null);
    useOnClickOutside(ref, () => setDatePopupVisible(false));

    const selectStatus = status => {
        setStartDate(null);
        setEndDate(null);

        dispatch({type: actionTypes.BOOKING_LIST_SET_STATUS, status})
        dispatch({type: actionTypes.BOOKING_LIST_SET_KEYWORD})
        pushBookingListUrl(null, status, '', null,null, null, false);
    }

    const selectActive = event => {
        selectStatus('active');
        event.preventDefault();
    }

    const selectArchived = event => {
        selectStatus('archived');
        event.preventDefault();
    }

    const selectTrash = event => {
        selectStatus('trashed');
        event.preventDefault();
    }

    const isActive = () => !bookingListVars.status || bookingListVars.status === 'active';
    const isArchived = () => bookingListVars.status === 'archived';
    const isTrashed = () => bookingListVars.status === 'trashed';

    const isDatePickerActive = () => false;

    const dateSelectorTitle = startDate && endDate
        ? `${format(startDate, 'yyyy-MM-dd')} → ${format(endDate, 'yyyy-MM-dd')}`
        : 'Select Date';

    const selectRange = (type) => {
        const today = new Date();
        let start, end;

        switch (type) {
            case 'thisMonth':
                start = new Date(today.getFullYear(), today.getMonth(), 1);
                end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case 'nextMonth':
                start = new Date(today.getFullYear(), today.getMonth() + 1, 1);
                end = new Date(today.getFullYear(), today.getMonth() + 2, 0);
                break;
            case 'monthAfter':
                start = new Date(today.getFullYear(), today.getMonth() + 2, 1);
                end = new Date(today.getFullYear(), today.getMonth() + 3, 0);
                break;
            case 'lastMonth': // Xử lý tháng trước
                start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                end = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case 'thisWeek':
                start = new Date(today);
                start.setDate(today.getDate() - today.getDay());
                end = new Date(start);
                end.setDate(start.getDate() + 6);
                break;
            case 'thisYear':
                start = new Date(today.getFullYear(), 0, 1);
                end = new Date(today.getFullYear(), 11, 31);
                break;
            case 'allTime':
                start = null;
                end = null;
                break;
            default:
                return;
        }

        setStartDate(start);
        setEndDate(end);

        if (start && end) {
            setDatePopupVisible(false);
            dispatch({type: actionTypes.BOOKING_LIST_SET_DATE, date: `${format(start, 'yyyy-MM-dd')}_${format(end, 'yyyy-MM-dd')}`})
            dispatch(bookingListSet(selectedHospital.id, bookingListVars.status, bookingListVars.keyword, `${format(start, 'yyyy-MM-dd')}_${format(end, 'yyyy-MM-dd')}`, bookingListVars.page, bookingListVars.sortColumn, bookingListVars.sortMode));
        }
        if(!start && !end) {
            setDatePopupVisible(false);
            dispatch({type: actionTypes.BOOKING_LIST_SET_DATE, date: null})
            dispatch(bookingListSet(selectedHospital.id, bookingListVars.status, bookingListVars.keyword, '', bookingListVars.page, bookingListVars.sortColumn, bookingListVars.sortMode));
        }
    };


    const selectDate = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);

        if (start && end) {
            setDatePopupVisible(false);
            dispatch({type: actionTypes.BOOKING_LIST_SET_DATE, date: `${format(start, 'yyyy-MM-dd')}_${format(end, 'yyyy-MM-dd')}`})
            dispatch(bookingListSet(selectedHospital.id, bookingListVars.status, bookingListVars.keyword, `${format(start, 'yyyy-MM-dd')}_${format(end, 'yyyy-MM-dd')}`, bookingListVars.page, bookingListVars.sortColumn, bookingListVars.sortMode));
        }

        if(!start && !end) {
            setDatePopupVisible(false);
            dispatch({type: actionTypes.BOOKING_LIST_SET_DATE, date: null})
            dispatch(bookingListSet(selectedHospital.id, bookingListVars.status, bookingListVars.keyword, '', bookingListVars.page, bookingListVars.sortColumn, bookingListVars.sortMode));
        }

    };

    const showDatePopup = (event) => {
        setDatePopupVisible(!datePopupVisible);
        event.preventDefault();
    }

    return (
        <ul className="nav nav-tabs ajax-tabs procedure-list-tabs" role="tablist">
            <TabItem isSelected={isActive()} clickHandler={selectActive} label="New" count={bookingListVars.count_active} />
            <TabItem isSelected={isArchived()} clickHandler={selectArchived} label="Archived" count={bookingListVars.count_archived} />
            <TabItem isSelected={isTrashed()} clickHandler={selectTrash} label="Trash" count={bookingListVars.count_trashed} />

            <li className="nav-item dropdown" ref={ref}>
                <a className={`nav-link`} href="#" onClick={showDatePopup}>
                    <span>{dateSelectorTitle}</span>
                    <i className="icon ico-small-down"></i>
                </a>
                <div className={`date-dropdown-menu tabs-dropdown-menu dropdown-menu-right${datePopupVisible ? ' show' : ''}`} aria-labelledby="dropdownMenuButton">
                    <div className="booking-list_daterange-block">
                        <DatePicker
                            selected={startDate}
                            onChange={selectDate}
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange
                            inline
                        />

                        <div className="date-quick-select">
                            <button onClick={() => selectRange('thisMonth')}>This Month</button>
                            <button onClick={() => selectRange('nextMonth')}>Next Month</button>
                            <button onClick={() => selectRange('monthAfter')}>The Month After</button>
                            <button onClick={() => selectRange('lastMonth')}>Last Month</button> {/* Thêm tháng trước */}
                            <button onClick={() => selectRange('thisWeek')}>This Week</button>
                            <button onClick={() => selectRange('thisYear')}>This Year</button>
                            <button onClick={() => selectRange('allTime')}>All Time</button>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    );
}

export default BookingList_Tabs;